<template>
  <div class="slider-controls">
    <button
      type="button"
      :disabled="leftControlsDisabled"
      class="slider-controls__arrow"
      @click="$emit('prevSlide')">
      <arrowhead-icon class="slider-controls__arrow-icon" />
    </button>

    <slot />

    <button
      type="button"
      :disabled="rightControlsDisabled"
      class="slider-controls__arrow "
      @click="$emit('nextSlide')">
      <arrowhead-icon class="slider-controls__arrow-icon" />
    </button>
  </div>
</template>

<script>
import ArrowheadIcon from 'Components/ui/Icons/ArrowheadIcon.vue';

export default {
  name: 'SliderControls',

  components: {
    ArrowheadIcon,
  },

  props: {
    leftControlsDisabled: {
      type: Boolean,
      default: false,
    },

    rightControlsDisabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
.slider-controls {
  //--controls-gap: 8px;
  //--controls-arrow-size: 32px;
  //--controls-arrow-hover-bg: #{$color--basic-blue};
  //--controls-arrow-border-color: #{$color--basic-dark-gray};
  //--controls-arrow-icon-size: 30%;

  display: flex;
  align-items: center;
  gap: var(--controls-gap, 8px);
  white-space: nowrap;
}

.slider-controls__arrow {
  width: var(--controls-arrow-size, 32px);
  height: var(--controls-arrow-size, 32px);
  border-radius: 50%;
  border: 1px solid var(--controls-arrow-border-color, $color--basic-dark-gray);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color .3s ease-out;
  cursor: pointer;
  user-select: none;
  transform: rotate(90deg);
  background-color: transparent;
  padding: 0;

  &:hover {
    background-color: var(--controls-arrow-hover-bg, $color--basic-blue);
  }

  &:active {
    background-color: rgba($color--basic-blue, .31);
  }

  &.disabled {
    pointer-events: none;
    background-color: $color--basic-unavailable;
  }
}

.slider-controls__arrow:last-child {
  transform: rotate(-90deg);
}

.slider-controls__arrow-icon {
  --width: var(--controls-arrow-icon-size, 30%)
}
</style>
